import { motion } from "framer-motion"
import React from "react"
import styled from "styled-components"

const StyledFigure = styled(motion.figure)`
  /* margin-top: var(--safety-padding) !important; */
  > svg {
    width: ${props => (props.Width ? props.Width : "calc(100%)")};
    height: auto;
  }
  > figcaption {
    text-align: center;
    font-size: calc(var(--tags) - 2px);
    font-style: italic;
  }
`

const Figure = props => {
  const Data = props.data
  const Width = props.Width
  const cardVariants = {
    offscreen: {
      opacity: 0,
      y: 20,
    },
    onscreen: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  }
  return (
    <StyledFigure
      Width={Width}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: 0.3 }}
      variants={cardVariants}
    >
      <Data />
      <figcaption>{props.caption}</figcaption>
    </StyledFigure>
  )
}

export default Figure
